import {Module} from 'vuex';
import {RootState} from '@/store';
import PlanEditResultConfigTabTypesEnum from '@/enums/PlanEditResultConfigTabTypesEnum';

type PlanEditResultEditState = {
    activeTabs: PlanEditResultConfigTabTypesEnum[];
    currentTabs: Array<Array<PlanEditResultConfigTabTypesEnum>>;
};

const PlanEditResultEditModule: Module<PlanEditResultEditState, RootState> = {
    namespaced: true,
    state: {
        activeTabs: [],
        currentTabs: [],
    },
    getters: {},
    mutations: {
        updateActiveTabs: (state, tabs) => (state.activeTabs = tabs),
        updateCurrentTabs: (state, tabs) => (state.currentTabs = tabs),
        clear: state => {
            state.activeTabs = [];
            state.currentTabs = [];
        },
    },
    actions: {},
};

export default PlanEditResultEditModule;
